import { Loader2, Trash2 } from "lucide-react";
import StatusBadge from "./StatusBadge";

export default function LeadsTable({ items, loading, onSelect, onDelete }) {
  if (loading) {
    return (
      <div className="surface p-12 text-center text-[#AEB7B7]" data-testid="admin-leads-table">
        <Loader2 size={20} strokeWidth={1.5} className="animate-spin inline mr-2" />
        Lädt…
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="surface p-12 text-center text-[#AEB7B7]" data-testid="admin-leads-table">
        Keine Einträge
      </div>
    );
  }

  return (
    <div className="surface overflow-x-auto" data-testid="admin-leads-table">
      <table className="w-full text-sm">
        <thead className="text-left text-[10px] uppercase tracking-[0.2em] text-[#AEB7B7] border-b border-[rgba(255,255,255,0.08)]">
          <tr>
            <th className="p-4">Datum</th>
            <th className="p-4">Name</th>
            <th className="p-4">Unternehmen</th>
            <th className="p-4">E-Mail</th>
            <th className="p-4">Standort</th>
            <th className="p-4">System</th>
            <th className="p-4">Status</th>
            <th className="p-4 text-right">Aktion</th>
          </tr>
        </thead>
        <tbody>
          {items.map((x) => (
            <tr
              key={x.id}
              className="border-b border-[rgba(255,255,255,0.06)] hover:bg-[#0B0F10] cursor-pointer"
              onClick={() => onSelect(x)}
              data-testid={`lead-row-${x.id}`}
            >
              <td className="p-4 text-[#AEB7B7] whitespace-nowrap">
                {x.created_at ? new Date(x.created_at).toLocaleDateString("de-DE") : ""}
              </td>
              <td className="p-4">
                <div className="font-medium">
                  {x.first_name} {x.last_name}
                </div>
                <div className="text-xs text-[#AEB7B7]">{x.role}</div>
              </td>
              <td className="p-4">{x.company || "—"}</td>
              <td className="p-4 text-[#AEB7B7]">{x.email}</td>
              <td className="p-4 text-[#AEB7B7]">
                {x.city_region || "—"}
                {x.available_area && (
                  <div className="text-xs">{x.available_area} m²</div>
                )}
              </td>
              <td className="p-4">{x.product_interest || "—"}</td>
              <td className="p-4">
                <StatusBadge status={x.lead_status} />
              </td>
              <td className="p-4 text-right">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(x.id);
                  }}
                  className="text-[#AEB7B7] hover:text-red-400 inline-flex"
                  aria-label="Löschen"
                  data-testid={`delete-${x.id}`}
                >
                  <Trash2 size={16} strokeWidth={1.5} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
